import { render, staticRenderFns } from "./OutReachEmailPerformance.vue?vue&type=template&id=5fb907c2&scoped=true&"
import script from "./OutReachEmailPerformance.vue?vue&type=script&lang=js&"
export * from "./OutReachEmailPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb907c2",
  null
  
)

export default component.exports